import React from "react";
const { List, fromJS } = require('immutable');

export const pathTraverse = (object, path) => {
    let array = path.split('.');
    let item = object;
    array.forEach((property) => {
        if (item !== null & item !== undefined) item = item[property];
    });

    return item;
};

export const displayErrors = (errors, path) => {
    let item = pathTraverse(errors, path);
    return item ? (<small className="form-text text-danger">{item}</small>) : null;
};

export const withTouchedError = (errors, touched, path) => {
    let error = pathTraverse(errors, path);
    let touch = pathTraverse(touched, path);
    return error && touch;
};

export const withTouchedErrorClass = (errors, touched, path) => {
    return (withTouchedError(errors, touched, path) ? 'form-control error' : 'form-control');
};

export const parsePropertiesErrors = (errors, path) => {
    let nested = fromJS(errors);
    const pathArray = path.split('.');

    nested = nested.updateIn(pathArray, (value) => {
        if (List.isList(value)) {
            let propertiesErrors = {};
            value.forEach((error, index) => {
                propertiesErrors[error.get('field')] = error.get('message');
            });
            return propertiesErrors;
        } else {
            return undefined;
        }
    });

    return nested.toJS();
};
